<template>
  <div style="padding: 0 10px;min-width: 1220px;">
    <ScanQuery @onQuery="queryCall" ph="输入快递单号/入库单号" ref="keepFocus" :showRest="true" @rest="
      query.code = '';
    sup_code = ''; supplierName = ''; supplierSpu = ''; stockCode = ''
    clearCall();
    " :disabled2="!!(supplierName || supplierSpu)" @input="codeInput">
      <template #label>
        <span>快递单号/入库单号：</span>
      </template>
      <template #form>
        <!-- <div v-if="queryData[0]?.inboundCode" style="display: flex; align-items: center; margin-right: 20px">
					<span style="width: 110px; margin-right: 10px">供应商款号:</span>
					<el-input v-model="sup_code" placeholder="输入供应商款号" @keyup.enter="queryCall({})"></el-input>
				</div> -->
        <div>
          <span>供应商名称：</span>
          <el-select v-model="supplierName" filterable remote reserve-keyword placeholder="请输入供应商名称"
            :remote-method="remoteMethod" :loading="loading" style="width: 250px;margin-right: 20px;"
            :disabled="!!stockCode" clearable>
            <el-option v-for="item in supplierList" :key="item.supplierShopName" :value="item.supplierShopName">
              {{ item.supplierShopName }}({{ platformType[item.purchaseChannel] }})
            </el-option>
          </el-select>
          <span>商品款号：</span>
          <el-input style="width: 150px;margin-right: 20px;" v-model="supplierSpu" placeholder="请输入商品款号"
            :disabled="!!stockCode"></el-input>
        </div>
      </template>
    </ScanQuery>
    <div class="infoBox">
      <div class="infoItems">
        <span style="margin-right: 20px">采购单号：
          <span style="font-size: 26px">
            <template v-if="packageInfo.purchaseNo.length == 1">
              <span>{{ packageInfo.purchaseNo[0].purchaseNo }}</span>
            </template>
            <template v-else-if="packageInfo.purchaseNo.length > 1">
              <span>多个采购单</span>
              <el-button type="text" @click="checkPurchaseList(packageInfo.purchaseNo)">点击查看</el-button>
            </template>
            <template v-else>
              <span>-</span>
            </template>
          </span>
        </span>
        <span>运单维护时间：
          <span style="font-size: 26px">{{
            packageInfo.createTime || "-"
            }}</span>
        </span>
        <span v-if="supplierSearchParams.shopName" style="margin-left: 20px">供应商名称：<span style="font-size: 26px;">{{ supplierSearchParams.shopName }}</span></span>
        <br />
        <template v-if="
          packageInfo.purchaseNo.length == 1 &&
          packageInfo.purchaseNo[0].purchaseRemark
        ">
          <span>采购备注：</span>
          <span style="font-size: 26px">{{
            packageInfo.purchaseNo[0].purchaseRemark
            }}</span>
          <br />
        </template>
        <span style="margin-right: 20px">订单来源：
          <span style="font-size: 26px">{{
            packageInfo.systemSource < 0 ? "-" : packageTypeStr[packageInfo.systemSource] }} </span>
          </span>
          <span style="margin-right: 20px">特殊质检要求：
            <span style="font-size: 26px; color: red">{{
              packageInfo.specialFlag == "-"
                ? "-"
                : packageInfo.specialFlag
                  ? "有"
                  : "无"
            }}</span>
          </span>
          <span style="margin-right: 20px">特殊入库要求：
            <span style="font-size: 26px; color: red">{{
              packageInfo.specialInboundFlag == "-"
                ? "-"
                : packageInfo.specialInboundFlag
                  ? "有"
                  : "无"
            }}</span>
          </span>
          <span style="margin-right: 20px; cursor: pointer" @click="checkLogistics">包裹数量：
            <span style="font-size: 26px; color: #008dde">{{
              packageInfo.logisticsNumberList
                ? packageInfo.logisticsNumberList.length
                : "-"
            }}</span>
          </span>
          <span style="margin-right: 20px" v-if="orderingOnBehalfOfCustomers">
            <span style="font-size: 26px; color: red">代客下单</span>
          </span>
          <span style="margin-right: 20px" v-if="packageInfo.allIncludeFlag === 1">
            <el-tag type="warning" effect="dark">一价全包</el-tag>
          </span>
          <span style="
						margin-right: 20px;
						color: red;
						font-size: 26px;
						font-weight: 800;
					" v-if="packageInfo.celebritiesFlag === 1">
            网红子店铺，需要联系客户
          </span>
          <span style="
						margin-right: 20px;
						color: red;
						font-size: 26px;
						font-weight: 800;
					" v-if="packageInfo.urgentWarehousing === 1">
            加急
          </span>
      </div>
      <div class="infoNums">
        <div class="infoNumBox">
          <div class="infoTitle">总数量</div>
          <div class="">{{ packageInfo.totalPurchaseNum }}</div>
        </div>
        <div class="infoNumBox">
          <div class="infoTitle">运输中</div>
          <div class="">{{ packageInfo.totalInTransitNum }}</div>
        </div>
        <div class="infoNumBox">
          <div class="infoTitle">已入库</div>
          <div class="">{{ packageInfo.totalStockInNum }}</div>
        </div>
      </div>
    </div>
    <el-tabs type="border-card" @tab-click="tabClick" v-model="tabsName" class="checkTabs">
      <el-tab-pane v-for="(i, index) in queryData" :key="index" :name="i.inboundCode">
        <span slot="label"> {{ i.inboundCode }}</span>
        <div style="display: flex;align-items: center;margin-bottom: 20px;">
          <span>供应商款号：</span>
          <el-input v-model="i.spuCode" style="width: 200px;" @keydown.native.enter="searchSpu(index)"></el-input>
          <el-button type="primary" style="margin: 0 10px 0 20px;" @click="searchSpu(index)">搜索</el-button>
          <el-button @click="resetSearch(index)">重置</el-button>
        </div>
        <WmsTable :columns="columns" isExpanded_hidden :is-pagination="query" @pageChange="pageChangeCall"
          :ref="`wmsTable${i.inboundCode}`" :dataSource="i.itemList" :rowClassFunc="rowClassNameCall"
          :hasHeader="false">
          <ImgPreviews slot="productImgActive" slot-scope="{ text, record, index }" :images="[text]" :lazy="false"/>
          <template slot="productName" slot-scope="{ text, record, index }">
            <div @click="toProductLink(record)" style="color: #008dde; white-space: wrap" v-if="record.productLink">
              {{ text }}
            </div>
            <div style="white-space: wrap" v-else>{{ text }}</div>
            <div v-show="record.supplierSpu" style="margin-top: 6px; white-space: wrap;font-size: 20px;">
              款号：<span style="font-weight: 600">{{
                record.supplierSpu
                }}</span>
            </div>
          </template>
          <template slot="specialCheck" slot-scope="{ text, record, index }">
            <div style="color: red; font-weight: 600">
              <div v-if="record.showCheckBtn" @click="
                addition = text;
              dialogVisible = true;
              " style="cursor: pointer">
                查看
              </div>
              <div v-else-if="
                record.spcialCheckList && record.spcialCheckList.length == 1
              ">
                <div style="word-wrap: break-word">
                  {{ record.spcialCheckList[0].specialCheckRequirement }}
                </div>
                <!-- <ImgPreviews style="flex-shrink: 0;" height="30" width="30" :images="[record.spcialCheckList[0].specialCheckRequirementImg]" v-if="record.spcialCheckList[0].specialCheckRequirementImg"/> -->
              </div>
              <div v-else>-</div>
            </div>
          </template>
          <template slot="directSaleFlag" slot-scope="{ text, record, index }">
            <div v-if="text == 1" style="color: red">直营</div>
            <div v-else>代采</div>
          </template>
          <template slot="checkAction" slot-scope="{ text, record, index }">
            <div>
              <el-radio-group v-model="record.volume" :disabled="record.hasVolume">
                <div style="text-align: left">
                  <el-radio-button label="XS">超小</el-radio-button>
                  <el-radio-button label="S">小</el-radio-button>
                  <el-radio-button label="M">中</el-radio-button>
                  <el-radio-button label="L">大</el-radio-button>
                  <el-radio-button label="XL">超大</el-radio-button>
                </div>
              </el-radio-group>
            </div>
            <div class="check__div--action">
              <IptNumber unit="件" v-model="record.warehousingAmount" :max="record.purchaseNum - record.confirmNum - record.stockInNum
                " />
              <el-checkbox v-model="record.isPrint">一键打印</el-checkbox>
              <el-button type="primary" @click="printMonad(record)" :disabled="!(
                record.purchaseNum -
                record.confirmNum -
                record.stockInNum
              ) > 0
                ">
                入库
              </el-button>
            </div>
          </template>
          <template slot="productSku" slot-scope="{ text, record, index }">
            <div>
              {{ text }}
            </div>
            <el-tag type="warning" effect="dark" v-if="record.allIncludeFlag === 1">一价全包</el-tag>
            <a v-if="record?.productCode" style="margin-left: 5px" target="_blank"
              :href="`https://s.theckb.com/ja/goods/${record?.productCode}`">
              CKB链接
            </a>
          </template>
          <template #spcialStockList="{ text, record }">
            <SpecialStock :item="record"
              v-if="packageInfo.specialInboundFlag && packageInfo.specialInboundFlag != '-' && i.inboundCode == tabsName" />
            <span v-else>-</span>
          </template>
          <div slot="expandedRender" slot-scope="{ record }">
            <el-collapse accordion @change="collapseChange(`wmsTable${i.inboundCode}`)"
              :key="record.id + i.queryDataKey + 'abnormal'">
              <el-collapse-item>
                <template slot="title">
                  <strong> 异常处理 </strong>
                </template>
                <el-tabs v-model="dataSourceAbnormalMap[
                  record.productSku + i.queryDataKey + 'abnormal'
                ]
                  " type="card" class="abnormalTabs">
                  <el-tab-pane label="异常上报采购" name="purchase" v-if="i.pushMarketFlag !== 1">
                    <AbnormalContent :abnormalOptionList="abnormalPurchase_inHouse" @submit="purchaseSubmit"
                      :record="record" :check_oem="check_oem" />
                  </el-tab-pane>
                  <el-tab-pane label="异常上报客户" name="client" v-if="record.purchaseType == 0"
                    :disabled="record.isShortage">
                    <AbnormalContent :abnormalOptionList="abnormalClient" checkType="popBtn" @submit="clientSubmit"
                      :record="record" />
                  </el-tab-pane>
                  <el-tab-pane label="次品登记" name="cip" :disabled="record.isShortage">
                    <AbnormalContent :abnormalOptionList="abnormalDefective" checkType="checkbox"
                      @submit="defectiveSubmit" :record="record" />
                  </el-tab-pane>
                </el-tabs>
              </el-collapse-item>
            </el-collapse>
            <el-collapse accordion @change="collapseChange(`wmsTable${i.inboundCode}`)"
              :key="record.id + i.queryDataKey">
              <el-collapse-item>
                <template slot="title">
                  <strong> 操作记录 </strong>
                </template>
                <template>
                  <div class="title">已入库批次:</div>
                  <WmsTable :is-pagination="false" :columns="operateColumns"
                    :dataSource="record.pkgList ? record.pkgList : []" :hasHeader="false">
                    <div slot="pkgCode" slot-scope="{ text, record, index }">
                      {{ text }}
                      <div class="crossDockingFlag" v-if="record.crossDockingFlag">
                        可越库
                      </div>
                    </div>
                    <div slot="printAction" slot-scope="{ text, record, index }" style="
												display: flex;
												justify-content: flex-start;
												align-items: center;
											">
                      <IptNumber unit="件" v-model="record.printNum" />
                      <el-button type="primary" @click="operatePrint(record)">
                        打印</el-button>
                    </div>
                    <div slot="productSku" slot-scope="{ text, record, index }" style="
												display: flex;
												justify-content: flex-start;
												align-items: center;
											">
                      <input type="text" v-model="text" />
                    </div>
                  </WmsTable>
                </template>
              </el-collapse-item>
            </el-collapse>
          </div>
        </WmsTable>
      </el-tab-pane>
    </el-tabs>

    <!--    采购单 end-->
    <!--    采购单 end-->
    <!--    采购单 end-->
    <choosePrint ref="choosePrintDialog"></choosePrint>
    <el-dialog title="特殊质检要求" :visible.sync="dialogVisible">
      <el-table :data="addition" :border="true" height="400">
        <el-table-column prop="platformOrderNo" label="订单号"></el-table-column>
        <el-table-column prop="num" label="数量">
          <template slot-scope="scope">
            {{ scope.row.sellQuantity || "-" }}
          </template>
        </el-table-column>
        <el-table-column prop="specialCheckRequirement" label="特殊质检要求"></el-table-column>
        <el-table-column prop="specialCheckRequirementImg" label="特殊质检要求图片">
          <template slot-scope="scope">
            <ImgPreviews :images="[scope.row.specialCheckRequirementImg]"></ImgPreviews>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="包裹信息" :visible.sync="dialogLogistics">
      <el-table :data="logisticsInfo" :border="true" height="400">
        <el-table-column prop="expressNo" label="运单号"></el-table-column>
        <el-table-column prop="status" label="签收状态">
          <template slot-scope="scope">
            {{ { 0: "未签收", 1: "已签收" }[scope.row.status] }}
          </template>
        </el-table-column>
        <el-table-column prop="signDate" label="签收时间"></el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog title="采购单明细" :visible.sync="purchaseListVisible" width="800px" :close-on-click-modal="false">
      <el-table :data="dialogPurchaseList" :border="true" height="400">
        <el-table-column prop="purchaseNo" label="采购单号" width="200"></el-table-column>
        <el-table-column prop="purchaseRemark" label="采购备注"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import AbnormalContent from "@/components/AbnormalContent.vue";
import ScanQuery from "@/components/ScanQuery";
import WmsTable from "@/components/WmsTable";
import ImgPreviews from "@/components/ImgPreviews";
import IptNumber from "@/components/IptNumber";
import AbnormalSubmit from "@/views/inHouse/components/Abnormal/AbnormalSubmit";
import DefectiveSubmit from "@/views/inHouse/components/Abnormal/DefectiveSubmit";
// import { packageTypeStr } from "@/types";
import { Descriptions } from "ant-design-vue";
import { audioPay } from "@/utils/tools";
import {
  packageTypeStr,
  abnormalPurchase_inHouse,
  abnormalClient,
  abnormalDefective,
} from "@/types";
import SpecialStock from "./components/SpecialStock/SpecialStock.vue";
import { checkColumns, checkOperateColumns } from "./checkData";
import {
  inHouseDoStockIn,
  shortageArrival,
  inHouseQuery,
  queryWithInboundCode,
  doStockInWithInboundCode,
  queryLogisticsInfo,
  newQueryWithInboundCode,
  newDoStockInWithInboundCode,
  querySpecialInboundRequirement,
  getSupplierShopNameListApi,
  getQueryWithSupplierApi
} from "@/apis/inHouse";
import {
  selectSpecialCheckInfo,
  getAdditionalItemsInfo,
  listAdditionalItemsInfo,
} from "@/apis/checking";
import choosePrint from "@/components/choosePrint/index.vue";
import { clientUrl } from "@/const/env";
let timer = null

export default {
  name: "Check",
  components: {
    [Descriptions.name]: Descriptions,
    [Descriptions.Item.name]: Descriptions.Item,
    DefectiveSubmit,
    AbnormalSubmit,
    ImgPreviews,
    IptNumber,
    ScanQuery,
    WmsTable,
    choosePrint,
    AbnormalContent,
    SpecialStock,
  },
  data() {
    return {
      sup_code: "",
      query: {
        code: "",
        // code: "",
        // current: 1,
        pageSize: 20,
        // total: 0
      },
      packageTypeStr,
      abnormalPurchase_inHouse,
      abnormalClient,
      abnormalDefective,
      packageInfo: {
        purchaseNo: "",
        systemSource: -1,
        createdTime: "",
        specialFlag: "-",
        specialInboundFlag: "-",
      },
      columns: checkColumns,
      operateColumns: checkOperateColumns,
      dataSource: [],
      dataSourceAbnormalMap: {},
      operateDataSource: [],
      printTemplate: "",
      dialogVisible: false,
      addition: [],
      dialogLogistics: false,
      logisticsInfo: [],
      queryData: [
        {
          inboundCode: "",
          queryDataKey: " ",
          itemList: [],
        },
      ],
      original_itemList: [],
      dialogPurchaseList: [],
      purchaseListVisible: false,
      tabsName: "",
      hasCheckedTableList: [],
      orderingOnBehalfOfCustomers: false,
      queryResult: {},
      supplierName: '',
      loading: false,
      supplierList: [],
      platformType: {
        TB: '淘宝',
        AM: '1688',
        TM: '天猫',
        VC: '搜款网',
        WS: '网商园',
        YW: '义乌小商品市场',
        OL: '线下',
        YS: '一手',
        XZ: '四季星座',
      },
      supplierSpu: '',
      stockCode: '',
      supplierSearchParams: {}
    };
  },
  mounted() {
    var focusFunc = setInterval(() => {
      console.log(document.activeElement)
      if (!!window.getSelection().toString()) {
        return;
      }
      if (
        document.activeElement.tagName == "INPUT" ||
        document.activeElement.tagName == "TEXTAREA" ||
        document.activeElement.classList.contains('ant-pagination-options-size-changer')
      ) {
        return;
      }
      if (this.$refs.keepFocus) {
        this.$refs.keepFocus.focusIpt(true);
      }
    }, 1000);

    // test
    // this.queryCall({ code: 'RK2025071000000010' })
  },
  beforeUnmount() {
    console.log("beforeUnmount");
    clearInterval(focusFunc);
  },
  watch: {
    $route: {
      handler: function (newVal, oldVal) {
        if (newVal.query.purchaseNew) {
          this.query.code = newVal.query.purchaseNew;
          this.getDataSource();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    check_oem: function () {
      return this.packageInfo.purchaseType == 1 ||
        this.packageInfo.purchaseType == 2
        ? "check_oem"
        : "";
    },
  },
  methods: {
    searchSpu(index){
      this.$set(this.queryData[index], 'itemList', this.queryData[index].copyList.filter((v) =>
          v.supplierSpu?.toLowerCase().includes(this.queryData[index].spuCode.toLowerCase())
        ))
        console.log(index, this.queryData)
    },
    resetSearch(index){
      this.queryData[index].spuCode = ''
      this.searchSpu(index)
    },
    codeInput(e) {
      console.log(e)
      this.stockCode = e
    },
    clearCall() {
      // this.queryData[0].itemList = this.original_itemList;
    },
    queryCall: function (payload) {
      console.log(payload.code);
      if (this.supplierName || this.supplierSpu) {
        const params = {}
        if (this.supplierName) {
          params.shopName = this.supplierName
        }
        if (this.supplierSpu) {
          params.supplierSpu = this.supplierSpu
        }
        this.supplierSearchParams = params
        this.getDataSource2();
        return
      }
      // if (!payload.code && this.sup_code) {
      //   // 筛选入库单里的商品
      //   console.log(this.original_itemList);
      //   this.queryData[0].itemList = this.original_itemList.filter((v) =>
      //     v.supplierSpu?.toLowerCase().includes(this.sup_code.toLowerCase())
      //   );
      //   return;
      // }
      payload.code || (this.queryData[0].itemList = this.original_itemList);
      this.query.code = payload.code;
      this.getDataSource();
    },
    pageChangeCall: function (payload) {
      this.query = {
        ...this.query,
        ...payload,
      };
      this.query.pageSize = payload.pageSize
      // console.log(this.query)
    },
    resetPage: function () {
      this.query = {
        ...this.query,
        current: 1,
        pageSize: this.query.pageSize,
        total: 0,
      };
      this.packageInfo = {
        purchaseNo: "",
        systemSource: -1,
        createdTime: "",
        specialFlag: "-",
        specialInboundFlag: "-",
      };
      this.dataSource = [];
      this.dataSourceAbnormalMap = {};
      this.operateDataSource = [];
    },
    abnormalCallback(call) {
      if (call) {
        let Arr = call.map((v) => {
          return {
            ...v,
            wantPrintNum: v.systemSource == 2 ? 1 : v.amount,
          };
        });
        this.$printPkg(1, this.packageInfo.systemSource, Arr).catch((res) => {
          this.$refs.choosePrintDialog.templatePrintByPkg(call);
        });
      }
      
      if (this.query.code) {
        this.getDataSource();
      } else {
        this.getDataSource2();
      }
    },
    async getDataSource() {
      const that = this;
      that.resetPage();
      const { code } = that.query;
      if (!(code && code !== "")) {
        audioPay(`请输入快递单或入库单号`);
        return;
      }
      const res = await newQueryWithInboundCode({ expressNo: code.trim() });
      if (res.code != 0) {
        return;
      }
      this.orderingOnBehalfOfCustomers = res.data.some(
        (v) => v.orderingOnBehalfOfCustomers === 1
      );
      const queryData = res.data
        .map((v, index) => {
          const queryDataKey = String(index) + String(new Date().getTime());
          const itemList = v.itemList.map((y) => {
            that.dataSourceAbnormalMap[
              y.productSku + queryDataKey + "abnormal"
            ] = v.pushMarketFlag === 1 ? 'client' : "purchase";
            return {
              ...y,
              imgTagFlag: v.imgTagFlag,
              imgDefectiveTagFlag: v.imgDefectiveTagFlag,
              pkgList: (y.pkgList || []).map((s) => {
                return {
                  ...s,
                  printNum: s.originAmount,
                  inboundCode: v.inboundCode,
                };
              }),
              expressNo: that.query.code,
              warehousingAmount: y.purchaseNum - y.confirmNum - y.stockInNum,
              isPrint: true,
              purchaseType: y.purchaseType,
              // unificationCustomerFullName: unificationCustomerFullName,
              id: y.productSku + queryDataKey,
              inboundCode: v.inboundCode,
              hasVolume: !!y.volume,
              showCheckBtn: y.spcialCheckList && y.spcialCheckList.length > 1, //多条特殊质检要求
            };
          });
          return {
            ...v,
            queryDataKey,
            // test
            // itemList: Array.from({ length: 100 }, v => ({ ...itemList[0], id: Math.random() }))
            itemList,
            copyList: [...itemList],
            spuCode: ''
          };
        })
        .sort((v, y) => {
          return (
            new Date(y.createTime).getTime() - new Date(v.createTime).getTime()
          );
        });
      this.queryData = queryData;
      this.original_itemList = this.queryData[0].itemList;
      this.sup_code = "";
      audioPay(`扫描完成`);
      this.tabClick({ index: 0 });
    },
    // 通过供应商搜索
    async getDataSource2() {
      const that = this;
      that.resetPage();
      if (!this.supplierName && !this.supplierSpu) {
        return;
      }

      const res = await getQueryWithSupplierApi(this.supplierSearchParams);
      if (res.code != 0) {
        return;
      }
      this.orderingOnBehalfOfCustomers = res.data.some(
        (v) => v.orderingOnBehalfOfCustomers === 1
      );
      const queryData = res.data
        .map((v, index) => {
          const queryDataKey = String(index) + String(new Date().getTime());
          const itemList = v.itemList.map((y) => {
            that.dataSourceAbnormalMap[
              y.productSku + queryDataKey + "abnormal"
            ] = v.pushMarketFlag === 1 ? 'client' : "purchase";
            return {
              ...y,
              imgTagFlag: v.imgTagFlag,
              imgDefectiveTagFlag: v.imgDefectiveTagFlag,
              pkgList: (y.pkgList || []).map((s) => {
                return {
                  ...s,
                  printNum: s.originAmount,
                  inboundCode: v.inboundCode,
                };
              }),
              expressNo: that.query.code,
              warehousingAmount: y.purchaseNum - y.confirmNum - y.stockInNum,
              isPrint: true,
              purchaseType: y.purchaseType,
              // unificationCustomerFullName: unificationCustomerFullName,
              id: y.productSku + queryDataKey,
              inboundCode: v.inboundCode,
              hasVolume: !!y.volume,
              showCheckBtn: y.spcialCheckList && y.spcialCheckList.length > 1, //多条特殊质检要求
            };
          });
          return {
            ...v,
            queryDataKey,
            // test
            // itemList: Array.from({ length: 100 }, v => ({ ...itemList[0], id: Math.random() }))
            itemList,
            copyList: [...itemList],
            spuCode: ''
          };
        })
        .sort((v, y) => {
          return (
            new Date(y.createTime).getTime() - new Date(v.createTime).getTime()
          );
        });
      this.queryData = queryData;
      this.original_itemList = this.queryData[0].itemList;
      this.sup_code = "";
      audioPay(`扫描完成`);
      this.tabClick({ index: 0 });
    },
    // 入库单按钮
    printMonad: function (r) {
      const {
        isPrint,
        expressNo,
        warehousingAmount,
        productSku,
        purchaseNo,
        purchaseType,
        stockInNum,
        confirmNum,
        num,
        inboundCode,
        volume,
        purchaseNoList,
      } = r;
      let orderCode;
      if (!volume) {
        this.$message.warning("请选择尺寸");
        return;
      }
      if (
        Number(warehousingAmount) + Number(stockInNum) + Number(confirmNum) >
        num
      ) {
        this.$message.warning("超过采购总数");
        return;
      }
      const params = {
        expressNo,
        productSku,
        purchaseNo,
        purchaseType,
        operationType: 1, // 1正常 2次品 3 异常上报客户 4 异常上报采购
        amount: warehousingAmount,
        orderCode: orderCode,
        inboundCode: inboundCode,
        volume,
        purchaseNoList,
      };
      if (warehousingAmount == 0 || !warehousingAmount) {
        this.$message.warning("入库数量必须大于0");
        return;
      }
      inHouseDoStockIn(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("入库成功");
          if (!isPrint) {
            if (this.query.code) {
              this.getDataSource();
            } else {
              this.getDataSource2();
            }
            return;
          }

          // let Arr = [...data];
          let Arr = data.map((v) => {
            return {
              ...v,
              wantPrintNum:
                v.systemSource == 2 || v.oemProductClassificationId == 3
                  ? 1
                  : v.amount,
            };
          });
          // this.$wmsPrint.print().templatePrintByPkg(Arr);
          this.$printPkg(1, this.packageInfo.systemSource, Arr).catch((res) => {
            this.$wmsPrint.print().templatePrintByPkg(Arr);
          });
          if (this.query.code) {
            this.getDataSource();
          } else {
            this.getDataSource2();
          }
        }
      });
    },
    // 操作记录打印
    operatePrint: function (record) {
      let Arr = [{ ...record, wantPrintNum: record.printNum }];
      this.$wmsPrint.print().templatePrintByPkg(Arr);
      return;
      this.$printPkg(1, this.packageInfo.systemSource, Arr).catch((res) => {
        this.$wmsPrint.print().templatePrintByPkg(Arr);
      });
    },
    toProductLink(record) {
      // 线下采购单统一跳转商品详情
      // if(/^XX.*$/.test(record.purchaseNoList?.[0])) {
      //   window.open(clientUrl() + '/goods/' + record.productCode)
      //   return
      // }
      if (record.productLink) {
        window.open(record.productLink);
      }
    },
    rowClassNameCall(record, index) {
      return record.num > record.confirmNum + record.stockInNum
        ? "activeCol"
        : "";
    },
    collapseChange(ref) {
      let that = this;
      console.log("wmsTable", ref);
      setTimeout(() => {
        console.log(that.$refs[ref]);
        that.$refs[ref][0].resetExpandHeight();
      }, 350);
    },
    checkLogistics() {
      if (!this.packageInfo.inboundCode) {
        return;
      }
      // if( this.packageInfo.logisticsNumberList && this.packageInfo.logisticsNumberList.length){
      //   this.dialogLogistics = true
      // }else{
      //   this.$message.warning("无包裹信息");
      // }
      queryLogisticsInfo({
        inboundOrderCode: this.packageInfo.inboundCode,
      }).then((res) => {
        if (res.data.length) {
          this.logisticsInfo = res.data;
          this.dialogLogistics = true;
        } else {
          this.$message.warning("无包裹信息");
        }
      });
    },
    purchaseSubmit(t) {
      const {
        expressNo,
        productSku,
        purchaseNo,
        purchaseType,
        stockInNum,
        confirmNum,
        purchaseNum,
        inboundCode,
        purchaseNoList,
      } = t._props.record;
      if (!t.abnormalType) {
        this.$message.warning("请选择异常类型");
        return;
      }
      if (t.abnormalType != "103" && t.abnormalType != "105") {
        if (
          Number(t.num) + Number(stockInNum) + Number(confirmNum) >
          purchaseNum
        ) {
          this.$message.warning("超过采购总数");
          return;
        }
      }
      const params = {
        expressNo,
        productSku,
        purchaseNo,
        purchaseType,
        operationType: 4,
        exceptionCodeList: [t.abnormalType],
        picRelation: t.qrCode,
        remark: t.textarea,
        amount: t.num,
        inboundCode: inboundCode,
        volume: t.volume,
        purchaseNoList,
      };
      if (t.abnormalType === "105") {
        params.isShortage = 1;
      }
      if (params.amount == 0 || !params.amount) {
        this.$message.error("入库数量必须大于0");
        return;
      }
      const api =
        params.isShortage == 1 ? shortageArrival : newDoStockInWithInboundCode;
      api(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.abnormalCallback(data);
        }
      });
    },
    clientSubmit(t) {
      const {
        expressNo,
        productSku,
        purchaseNo,
        purchaseType,
        stockInNum,
        confirmNum,
        purchaseNum,
        inboundCode,
        purchaseNoList,
      } = t._props.record;
      if (
        Number(t.num) + Number(stockInNum) + Number(confirmNum) >
        purchaseNum
      ) {
        this.$message.warning("超过采购总数");
        return;
      }
      const params = {
        expressNo,
        productSku,
        purchaseNo,
        purchaseType,
        operationType: 3,
        exceptionCodeList: t.abnormalTypeList,
        exceptionItemDtoList: t.exceptionItemDtoList,
        picRelation: t.qrCode,
        remark: t.textarea,
        amount: t.num,
        inboundCode: inboundCode,
        volume: t.volume,
        purchaseNoList,
      };
      if (params.exceptionItemDtoList.length == 0) {
        this.$message.error("请勾选异常类型");
        return;
      }
      if (params.amount == 0 || !params.amount) {
        this.$message.error("入库数量必须大于0");
        return;
      }
      inHouseDoStockIn(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.abnormalCallback(data);
        }
      });
    },
    defectiveSubmit(t) {
      const {
        expressNo,
        productSku,
        purchaseNo,
        purchaseType,
        stockInNum,
        confirmNum,
        purchaseNum,
        inboundCode,
        purchaseNoList,
      } = t._props.record;
      if (
        Number(t.num) + Number(stockInNum) + Number(confirmNum) >
        purchaseNum
      ) {
        this.$message.warning("超过采购总数");
        return;
      }
      const params = {
        expressNo,
        productSku,
        purchaseNo,
        purchaseType,
        operationType: 2,
        exceptionCodeList: t.abnormalTypeList,
        picRelation: t.qrCode,
        remark: t.textarea,
        amount: t.num,
        inboundCode: inboundCode,
        volume: t.volume,
        purchaseNoList,
      };
      if (params.exceptionCodeList.length == 0) {
        this.$message.error("请勾选异常类型");
        return;
      }
      if (params.amount == 0 || !params.amount) {
        this.$message.error("入库数量必须大于0");
        return;
      }
      inHouseDoStockIn(params).then(({ code, data }) => {
        if (code === 0) {
          this.$message.success("成功");
          this.abnormalCallback(data);
        }
      });
    },
    async tabClick(e) {
      const keepTargetTab =
        this.codeBack == this.query.code &&
        this.queryData.some((v) => v.inboundCode == this.tabsName);
      const index = keepTargetTab
        ? this.queryData.findIndex((v) => v.inboundCode == this.tabsName)
        : e.index;
      this.setPackageInfo(this.queryData[index]);
      this.hasCheckedTableList.push(this.queryData[index].inboundCode);
    },
    setPackageInfo(packageItem) {
      function duplicateRemoval(key, arr) {
        let newArr = arr.filter(
          (item, index) => arr.findIndex((v) => v[key] == item[key]) === index
        );
        return newArr;
      }
      this.tabsName = packageItem.inboundCode;
      this.codeBack = this.query.code;
      this.packageInfo = {
        createTime: packageItem.createTime,
        purchaseType: packageItem.purchaseType,
        specialFlag: packageItem.specialFlag,
        systemSource: packageItem.systemSource,
        totalInTransitNum: packageItem.totalInTransitNum,
        totalPurchaseNum: packageItem.totalPurchaseNum,
        totalStockInNum: packageItem.totalStockInNum,
        purchaseNo: duplicateRemoval(
          "purchaseNo",
          packageItem.purchaseList
            .map((v) => {
              return v.purchaseItemList.map((y) => {
                return {
                  ...y,
                  purchaseRemark: v.purchaseRemark,
                };
              });
            })
            .flat()
        ),
        logisticsNumberList: Array.from(
          new Set(
            packageItem.purchaseList
              .map((v) => {
                return v.logisticsNumberList;
              })
              .flat()
          )
        ),
        inboundCode: packageItem.inboundCode,
        allIncludeFlag: packageItem.allIncludeFlag,
        specialInboundFlag: packageItem.specialInboundFlag,
        celebritiesFlag: packageItem.celebritiesFlag,
        urgentWarehousing: packageItem.urgentWarehousing
      };
    },
    checkPurchaseList(list) {
      this.dialogPurchaseList = list;
      this.purchaseListVisible = true;
    },
    remoteMethod(e) {
      console.log(e, this.supplierName)
      clearTimeout(timer)
      this.loading = true
      setTimeout(() => {
        timer = getSupplierShopNameListApi({
          // country: 'CN',
          pageNum: 1,
          pageSize: 20,
          noMask: true,
          supplierShopName: e
        }).then((res) => {
          console.log(res)
          this.supplierList = res.data.records || []
          this.loading = false
        })
      }, 800)

    }
  },
};
</script>
<style lang="less" scoped>
.line--3 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}

.title__header {
  height: 20px;
  margin: 0;
  line-height: 20px;
}

.title__header>strong {
  font-size: 18px;
}

.check__div--action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.table-s {
  padding: 20px;

  .title {
    font-size: 18px;
    font-weight: 800;
  }
}

.infoBox {
  width: 100%;
  background-color: #bbdaf9;
  padding: 10px 4px;
  display: flex;
  justify-content: space-between;
}

.infoItems {
  text-align: left;
}

.infoNums {
  display: flex;
  align-items: center;
}

.infoNumBox div {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 30px;
  background-color: #fff;
  margin-right: 4px;
}

.infoNumBox .infoTitle {
  background-color: #bccad9;
}

::v-deep.abnormalTabs>.el-tabs__content {
  overflow: visible;
}

.crossDockingFlag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0px 6px;
  color: red;
  border: 1px solid red;
  border-radius: 2px;
  margin-left: 4px;
}
</style>
<style>
.activeCol {
  background-color: rgba(255, 251, 0, 0.5);
}

.checkTabs {
  margin-top: 8px;
}

.checkTabs>.is-active {
  background-color: aqua;
}
</style>
